export const pricingPlans = [
  {
    id: 'monthly',
    name: "Mensile",
    price: 15,
    period: "mese",
    description: "Quota mensile di accesso al servizio di doposcuola. Frequenza, orari e modalita vengono confermati prima dell'avvio.",
    features: [
      "Accesso al supporto compiti e studio per elementari e medie",
      "Raccolta iniziale di classe, materie e bisogni scolastici",
      "Organizzazione di calendario, frequenza e modalita",
      "Metodo di studio, autonomia e gestione dei compiti",
      "Comunicazione essenziale con la famiglia"
    ],
    popular: false,
    stripePaymentLink: "https://buy.stripe.com/bJe00kcef8A5bcqcKo6g803"
  },
  {
    id: 'quarterly',
    name: "Trimestrale",
    price: 30,
    period: "trimestre",
    description: "Percorso di tre mesi per dare continuita al supporto scolastico e monitorare meglio i progressi.",
    features: [
      "Tutti i vantaggi del piano mensile",
      "Supporto organizzato su tre mesi",
      "Obiettivi didattici definiti con la famiglia",
      "Aggiornamenti periodici sull'andamento dello studente",
      "Priorita nella programmazione degli incontri disponibili"
    ],
    popular: true,
    savings: "Risparmi EUR 15 rispetto al mensile",
    stripePaymentLink: "https://buy.stripe.com/aFa14ofqr17Da8mcKo6g806"
  },
  {
    id: 'semester',
    name: "Semestrale",
    price: 50,
    period: "semestre",
    description: "Percorso di sei mesi pensato per consolidare metodo, autonomia, organizzazione e serenita nello studio.",
    features: [
      "Tutti i vantaggi del piano trimestrale",
      "Supporto organizzato su sei mesi",
      "Piano di lavoro scolastico personalizzato",
      "Confronti periodici con la famiglia",
      "Programmazione piu stabile del percorso"
    ],
    popular: false,
    savings: "Risparmi EUR 40 rispetto al mensile",
    stripePaymentLink: "https://buy.stripe.com/dRm7sMcef5nTeoCfWA6g807"
  },
  {
    id: 'annual',
    name: "Annuale",
    price: 90,
    period: "anno",
    description: "Percorso annuale per famiglie che vogliono un riferimento stabile durante l'anno scolastico.",
    features: [
      "Tutti i vantaggi del piano semestrale",
      "Supporto organizzato su dodici mesi",
      "Continuita nel metodo di studio",
      "Confronti programmati con la famiglia",
      "Pianificazione piu ampia degli obiettivi scolastici"
    ],
    popular: false,
    savings: "Risparmi EUR 90 rispetto al mensile",
    stripePaymentLink: "https://buy.stripe.com/eVq5kEa67eYtcgu11G6g805"
  },
  {
    id: 'custom',
    name: "Percorso intensivo personalizzato",
    price: 1000,
    period: "pacchetto",
    description: "Pacchetto personalizzato di tutoraggio educativo e supporto allo studio, definito dopo call conoscitiva con il genitore.",
    features: [
      "Call conoscitiva approfondita con il genitore",
      "Analisi di classe, materie, difficolta scolastiche e obiettivi",
      "Piano personalizzato di doposcuola, metodo e organizzazione",
      "Monitoraggio piu ravvicinato e confronto con la famiglia",
      "Non include diagnosi, terapia, cure o prestazioni sanitarie"
    ],
    popular: false,
    requiresCall: true,
    stripePaymentLink: "https://buy.stripe.com/7sYcN62DFbMh5S6h0E6g809"
  }
];

export const faqs = [
  {
    question: "Cosa comprende il servizio?",
    answer: "Offriamo supporto educativo e didattico per bambini e ragazzi di scuola primaria e secondaria di primo grado: compiti, metodo di studio, organizzazione, recupero delle lacune e maggiore autonomia nello studio."
  },
  {
    question: "Il servizio e online o in presenza?",
    answer: "Il supporto puo essere online o in presenza, in base alla zona, alla disponibilita degli educatori e alle esigenze della famiglia. La modalita viene chiarita prima dell'attivazione."
  },
  {
    question: "E un servizio individuale o di gruppo?",
    answer: "Dipende dal bisogno dello studente e dal percorso scelto. Possiamo proporre supporto individuale, piccoli gruppi o pacchetti personalizzati dopo una call conoscitiva."
  },
  {
    question: "Seguite anche studenti con DSA o BES?",
    answer: "Si, possiamo offrire supporto didattico per studenti con DSA/BES o difficolta come dislessia, disgrafia, disortografia, discalculia, ADHD e difficolta di attenzione o organizzazione. Il servizio resta educativo e scolastico: non effettuiamo diagnosi, terapia o prestazioni sanitarie."
  },
  {
    question: "Chi segue gli studenti?",
    answer: "Gli studenti sono affiancati da figure educative e tutor selezionati per il supporto allo studio. Prima dell'avvio raccogliamo le informazioni necessarie per assegnare il percorso piu adatto."
  },
  {
    question: "Come viene monitorato il progresso?",
    answer: "Durante il percorso osserviamo partecipazione, autonomia, gestione dei compiti, organizzazione e risultati scolastici. Quando previsto, aggiorniamo la famiglia con confronti o report periodici."
  },
  {
    question: "Cosa succede nella prima settimana?",
    answer: "La prima fase serve a conoscere lo studente, capire materie, orari, difficolta, obiettivi della famiglia e livello di autonomia. Da li impostiamo il metodo di lavoro piu adatto."
  },
  {
    question: "Esistono prestazioni piu mirate?",
    answer: "Si. Per situazioni piu complesse facciamo prima una call con il genitore e, quando opportuno, con lo studente. In quei casi prepariamo pacchetti personalizzati con obiettivi, durata e prezzo definiti prima del pagamento."
  },
  {
    question: "Il prezzo include supporto giornaliero?",
    answer: "I piani indicano l'accesso al servizio e al supporto continuativo secondo disponibilita, calendario e organizzazione concordata. Frequenza, orari e modalita vengono sempre confermati prima dell'avvio."
  },
  {
    question: "Posso disdire?",
    answer: "Si. Le condizioni di cancellazione e rimborso sono indicate nella pagina Politica rimborsi e cancellazioni."
  }
];

export const howItWorks = [
  {
    step: "1",
    title: "Richiesta o iscrizione",
    description: "La famiglia indica eta, classe, bisogni scolastici, materie e obiettivi."
  },
  {
    step: "2",
    title: "Call conoscitiva",
    description: "Quando serve, facciamo una chiamata con il genitore e valutiamo il percorso piu adatto."
  },
  {
    step: "3",
    title: "Avvio del supporto",
    description: "Organizziamo modalita, orari e attivita: compiti, metodo, recupero e autonomia."
  },
  {
    step: "4",
    title: "Monitoraggio",
    description: "Seguiamo l'andamento dello studente e manteniamo un confronto chiaro con la famiglia."
  }
];

export const whyChooseUs = [
  {
    icon: "Heart",
    title: "Serenita in famiglia",
    description: "Aiutiamo a ridurre tensioni e conflitti legati ai compiti a casa."
  },
  {
    icon: "BookOpen",
    title: "Metodo di studio",
    description: "Lavoriamo su organizzazione, autonomia e strategie concrete."
  },
  {
    icon: "Users",
    title: "Supporto umano",
    description: "Ogni studente viene seguito con attenzione, ascolto e continuita."
  },
  {
    icon: "MessageCircle",
    title: "Percorsi mirati",
    description: "Per bisogni specifici costruiamo pacchetti personalizzati dopo una call."
  },
  {
    icon: "Users",
    title: "Dialogo con i genitori",
    description: "La famiglia resta informata su metodo, progressi e passaggi importanti."
  },
  {
    icon: "CheckCircle",
    title: "Chiarezza",
    description: "Servizi, condizioni, limiti e modalita vengono spiegati prima dell'avvio."
  }
];
